import { render, staticRenderFns } from "./accountForm.vue?vue&type=template&id=a2fb4a88&scoped=true&"
import script from "./accountForm.vue?vue&type=script&lang=js&"
export * from "./accountForm.vue?vue&type=script&lang=js&"
import style0 from "./accountForm.vue?vue&type=style&index=0&id=a2fb4a88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fb4a88",
  null
  
)

export default component.exports